import { render } from "./GoogleLoginButton.vue?vue&type=template&id=b47b0414&scoped=true&ts=true"
import script from "./GoogleLoginButton.vue?vue&type=script&lang=ts"
export * from "./GoogleLoginButton.vue?vue&type=script&lang=ts"

import "./GoogleLoginButton.vue?vue&type=style&index=0&id=b47b0414&lang=scss&scoped=true"

import exportComponent from "/Users/kameyamanaoki/dev/mingaku/admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b47b0414"]])

export default __exports__